import Dialog from "~/ui-rtk/components/ui/common/Dialog"
import { Button } from "~/ui-rtk/components/ui/controls"

interface KPIExportSuccessDialogProps {
  isOpen: boolean
  onClose: () => void
}

export default function KPIExportSuccessDialog({
  isOpen,
  onClose,
}: KPIExportSuccessDialogProps) {
  return (
    <Dialog
      isOpen={isOpen}
      handleClose={onClose}
      width={520}
      classes={{
        container:
          "bg-system-blue-900 rounded-system-lg p-0 relative flex flex-col max-w-md w-full border border-system-blue-700 shadow-deep",
      }}
    >
      {/* Title Section */}
      <div className="flex flex-col items-start pt-8 px-8">
        <h2 className="text-2xl font-bold text-white mb-2">
          Download Successful!
        </h2>
        <p className="text-system-gray-300 text-base">
          Your KPI tables have been successfully downloaded
        </p>
      </div>

      {/* Content Section */}
      <div className="px-8 py-6">
        {/* Important Note Box */}
        <div className="bg-system-blue-800 border border-system-blue-600 rounded-system-lg p-5 space-y-3">
          <div className="flex items-start gap-3">
            <div className="flex-1">
              <h3 className="font-semibold text-system-gray-100 text-sm mb-2 text-left">
                Important Note
              </h3>
              <p className="text-system-gray-300 text-sm leading-relaxed text-left">
                Brand Value metrics are dynamic and update weekly as we
                incorporate new performance data, experiments, and network
                insights. Figures will change over time—this is a sign the model
                is learning and improving.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Button Section */}
      <div className="px-8 pb-8">
        <Button
          variant={{ variant: "solid", color: "blue" }}
          className="w-full h-11 font-semibold rounded-system-md text-white bg-system-success-700 hover:bg-system-success-600 transition-colors border border-system-success-600"
          onClick={onClose}
        >
          Got It
        </Button>
      </div>
    </Dialog>
  )
}
